/**
 * FeedOnlineConnections.js — EcoScienceInnova
 * Sidebar widget: online/active connections list (Reverted to mock version).
 *
 * Props:
 *  - connections: [{ id, name, role, online }]
 *  - onMessage:   (connectionId) => void
 *  - title:       string
 */
import React from 'react';
import { FaComments } from 'react-icons/fa';
import FeedAvatar from './FeedAvatar';
import FeedSidebarCard from './FeedSidebarCard';
import './feed.shared.css';

const FeedOnlineConnections = ({
    connections = [],
    onMessage,
    title = 'Conexiones activas',
}) => {
    return (
        <FeedSidebarCard title={title}>
            <div className="feed-widget-scroll">
                {connections.map(c => (
                    <div key={c.id} className="feed-conn-item">
                        <div className="feed-conn-avatar-wrap">
                            <FeedAvatar name={c.name} src={c.photo} size={36} />
                            <span className={`feed-online-dot ${c.online ? 'online' : ''}`} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <p className="feed-conn-name">{c.name}</p>
                            {c.role && <p className="feed-conn-role">{c.role}</p>}
                        </div>
                        <button
                            className="feed-msg-btn"
                            title={`Mensaje a ${c.name}`}
                            onClick={() => onMessage?.(c.id)}
                        >
                            <FaComments style={{ color: '#FF6600' }} />
                        </button>
                    </div>
                ))}
            </div>
        </FeedSidebarCard>
    );
};

export default FeedOnlineConnections;
